import { useCart } from "@/context/CartContext";
import { Link } from "react-router-dom";
import { X, Minus, Plus, Trash2 } from "lucide-react";
import { rupee } from "@/lib/api";

export default function CartDrawer() {
  const { open, setOpen, items, update, remove, subtotal } = useCart();
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-[#121212]/50" onClick={() => setOpen(false)} />
      <aside className="absolute right-0 top-0 h-full w-full sm:w-[440px] bg-[#FBF9F5] flex flex-col shadow-2xl">
        <div className="flex items-center justify-between p-6 border-b border-[#E2DDD5]">
          <div className="font-serif text-xl tracking-widest">YOUR BAG</div>
          <button onClick={() => setOpen(false)} data-testid="cart-drawer-close"><X size={22} /></button>
        </div>
        <div className="flex-1 overflow-auto p-6 space-y-6">
          {items.length === 0 && <p className="text-sm text-[#8C867D] text-center py-20">Your bag is empty.</p>}
          {items.map((i) => (
            <div key={i.product_id} className="flex gap-4" data-testid={`cart-item-${i.product_id}`}>
              <img src={i.image} alt={i.name} className="w-20 h-24 object-cover bg-[#F5F2EB]" />
              <div className="flex-1">
                <div className="text-sm font-medium">{i.name}</div>
                <div className="text-xs text-[#8C867D] mt-1">{rupee(i.price)}</div>
                <div className="flex items-center gap-3 mt-3">
                  <button onClick={() => update(i.product_id, i.quantity - 1)} className="p-1 border border-[#E2DDD5]" data-testid={`cart-decr-${i.product_id}`}><Minus size={12} /></button>
                  <span className="text-sm w-6 text-center">{i.quantity}</span>
                  <button onClick={() => update(i.product_id, i.quantity + 1)} className="p-1 border border-[#E2DDD5]" data-testid={`cart-incr-${i.product_id}`}><Plus size={12} /></button>
                  <button onClick={() => remove(i.product_id)} className="ml-auto text-[#8C867D] hover:text-[#5B1C22]" data-testid={`cart-remove-${i.product_id}`}><Trash2 size={14} /></button>
                </div>
              </div>
              <div className="text-sm">{rupee(i.price * i.quantity)}</div>
            </div>
          ))}
        </div>
        {items.length > 0 && (
          <div className="border-t border-[#E2DDD5] p-6 space-y-4">
            <div className="flex justify-between text-sm">
              <span className="uppercase tracking-widest">Subtotal</span>
              <span className="font-medium">{rupee(subtotal)}</span>
            </div>
            <Link to="/checkout" onClick={() => setOpen(false)} className="btn-lux w-full" data-testid="cart-drawer-checkout-button">Proceed to Checkout</Link>
          </div>
        )}
      </aside>
    </div>
  );
}
